import React, { useEffect } from 'react'
import { Screen } from '~common/screen'
import { StyledScreen } from '~common/screen'
import OkStatusIcon from '~images/chats-page/ok_status.svg'
import Form from '~/components/form'
import { dividedByThree } from '~helpers/constant'
import ym from 'react-yandex-metrika'

interface IPriceObject {
  whatsApp: { summ: number, currency: string }
  telegram: { summ: number, currency: string }
}

interface IPricingDetailsProps {
  price: IPriceObject,
  country: string
}

const PricingDetails: React.FC<IPricingDetailsProps> = ({ price, country }) => {

  return (
    <Screen
      title={<span><StyledScreen.GreenText>Что входит в</StyledScreen.GreenText> стоимость</span>}
      bottomLine
      className='pricing-details'
    >
      <div className="pricing-details__container">
        <div className="pricing-details__price-wrapper">
          <div className="pricing-details__features">
            <p className="pricing-details__feature">
              <span className="pricing-details__feature-icon"><OkStatusIcon /></span>
              <span className="pricing-details__feature-text">Лицензия на сервис с возможностью писать первым</span>
            </p>
            <p className="pricing-details__feature">
              <span className="pricing-details__feature-icon"><OkStatusIcon /></span>
              <span className="pricing-details__feature-text">Неограниченное количество сообщений и диалогов</span>
            </p>
            <p className="pricing-details__feature">
              <span className="pricing-details__feature-icon"><OkStatusIcon /></span>
              <span className="pricing-details__feature-text">Настройка и внедрение за 60 секунд</span>
            </p>
            <p className="pricing-details__feature">
              <span className="pricing-details__feature-icon"><OkStatusIcon /></span>
              <span className="pricing-details__feature-text">До 5 номеров за оплаченный период</span>
            </p>
            <p className="pricing-details__feature">
              <span className="pricing-details__feature-icon"><OkStatusIcon /></span>
              <span className="pricing-details__feature-text">Интеграция с СРМ системой</span>
            </p>
            <p className="pricing-details__feature">
              <span className="pricing-details__feature-icon"><OkStatusIcon /></span>
              <span className="pricing-details__feature-text">Заботливая техподдержка 24/7</span>
            </p>
          </div>
          <div className="pricing-details__price-coll">
            <div className="pricing-details__price">
              <div className="pricing-details__price-inner">
                <div className="pricing-details__price-line">
                  <div className="pricing-details__price-label">WhatsApp:</div>
                  <div className={`pricing-details__price-summ pricing-details__price-summ_${country}`}>{dividedByThree(price.whatsApp.summ, ' ')} {price.whatsApp.currency}</div>
                </div>
                <div className="pricing-details__price-line">
                  <div className="pricing-details__price-label">Telegram:</div>
                  <div className={`pricing-details__price-summ pricing-details__price-summ_${country}`}>{dividedByThree(price.telegram.summ, ' ')} {price.telegram.currency}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="pricing-details__form">
          <p className='pricing-details__form-text'>Протестируйте чаты 7 дней бесплатно и убедитесь в их удобстве и эффективности</p>
          <Form
            formType='service'
            text='Протестировать'
            pageName='Чаты'
            onSubmit={() => {
              ym('reachGoal', 'lead_chats', 631388)
            }}
          />
        </div>
      </div>
    </Screen>
  )
}

export default PricingDetails